const shaka = require('external/shaka-player.ui.debug');

const SkipForwardButton = class extends shaka.ui.Element {
  constructor(parent: typeof SkipForwardButton, controls: ShakaControl) {
    super(parent, controls);

    // The actual button that will be displayed
    this.button_ = document.createElement('button') as HTMLButtonElement;
    this.button_.textContent = '+10';
    this.button_.classList.add('shaka-skip-forward');

    this.parent.appendChild(this.button_);

    this.eventManager.listen(this.button_, 'click', () => {
      this.player.getMediaElement().currentTime += 10;
    });
  }
};

// Factory that will create a button at run time.
SkipForwardButton.Factory = class {
  create(rootElement, controls) {
    return new SkipForwardButton(rootElement, controls);
  }
};

export default SkipForwardButton;
